import * as types from '../mutation-types'

//建议对于getters,actions都加上模块名
// initial state
const state = {
  leftSideOpen: false, //左边关闭状态 true为关闭 false 为未关闭
	showTag: true,
	showTip: false
}

// getters
const getters = {
  framework_leftSideOpenStatus: state => state.leftSideOpen, //获取左边是否关闭状态
	farmework_showTip: state => state.showTip
}

// actions
const actions = {
  //开启关闭左边菜单
  frameworkToggleLeftSideStatus ({ commit, state }) {
    commit(types.FRAMEWORK_TOGGLE_LEFTSIDEOPEN);
  }, 
	frameworkToggleTips ({commit,state}, params) {
		commit(types.FRAMEWORK_TOGGLE_TIPS, params);
	}
}

// mutations
const mutations = {
  //开启关闭左边菜单
  [types.FRAMEWORK_TOGGLE_LEFTSIDEOPEN] (state) {
      state.leftSideOpen = !state.leftSideOpen;
  }, 
	[types.FRAMEWORK_TOGGLE_TIPS] (state, params) {
	    state.showTip = params.show;
	}
}

export default {
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/vuex/modules/framework.js